import { callLambdaApi } from "../callLambdaApi";
import { ApiNames, Methods } from "../constants";

export class PredictionApiCommunicator {
  fetch(id) {
    console.log("fetch()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${id}`,
    });
  }

  /**  @returns {Promise<import('api').GETResponse<import("models").MLModel[]>} */
  list() {
    console.log("list()");
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
    });
  }

  create(mlModelId, resultId, fileName, options) {
    return callLambdaApi({
      method: Methods.POST,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL(),
      payload: { body: {'mlModelId': mlModelId, 'mlModelResultId': resultId, 'fileName': fileName, 'options': options} },
    });
  }

  delete(predictionId) {
    return callLambdaApi({
      method: Methods.DELETE,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${predictionId}`,
    });
  }

  /**
   * Returns the default serverless api endpoint
   * @private
   */
  _buildBaseURL() {
    return `/internalprediction`;
  }
}
